/**
 * Notes React Query key roots. Own tiny module (precedent:
 * `components/flow/contact-state-keys.ts`) so the code that defines a notes
 * query and the code that invalidates it (`useFlowNotesLive`) read the same
 * constant and the root segment can never drift.
 */

export const FLOW_NOTES_KEY = ['flow-notes'] as const;
export const FLOW_NOTES_SUMMARIES_KEY = ['flow-notes-summaries'] as const;
export const FLOW_NOTES_MENTION_CANDIDATES_KEY = ['flow-notes-mention-candidates'] as const;
